/// <amd-module name="Agile/Contracts/Constants" />
/** Parent Id value for the work items that do not have a parent, e.g. an unparented task  */
export const Unparented = 0;
